import { useTranslation } from "react-i18next";

import { OrganizationUser } from "@organization/models/OrganizationUser";

import { useUserContext } from "@hooks/useUserContext";

import { OrganizationRoleDropDown } from "./OrganizationRoleDropDown";
import { ReadonlyDisplayName } from "./ReadonlyDisplayName";
import { ReadonlyUserEmail } from "./ReadonlyUserEmail";

interface Props {
  organizationUser: OrganizationUser;
  organizationRole: string;
  handleRoleChange: (newValue: string, isValid: boolean) => void;
  isBusy: boolean;
}

export const NameEmailRoles = (props: Props) => {
  const { organizationUser, organizationRole, handleRoleChange, isBusy } =
    props;

  const { t: tUser } = useTranslation(undefined, {
    keyPrefix: "user"
  });

  const { user } = useUserContext();

  return (
    <>
      <ReadonlyUserEmail
        id="readOnlyEmailAddress"
        label={tUser("email.label")}
        initialEmailValue={organizationUser.emailAddress}
      />

      <ReadonlyDisplayName
        id="readOnlyDisplayName"
        label={tUser("display-name.label")}
        initialNameValue={organizationUser.displayName}
      />

      <OrganizationRoleDropDown
        label={tUser("role.label")}
        selectedRole={organizationRole}
        disabled={user.id === organizationUser.id || isBusy}
        onRoleChange={handleRoleChange}
      />
    </>
  );
};
